const SCENE_CONFIG = {
  backgroundColor: 0x201919,
  antialias: false,
  fxaaPass: false,
  gammaCorrectionPass: false,
  maxPixelRatio: 2,
  isMobile: false,
  outlinePass: {
    enabled: true,
    color: '#ffffff',
    edgeGlow: 1,
    edgeStrength: 4,
    edgeThickness: 1,
    pulsePeriod: 4,
  },
};

export default SCENE_CONFIG;
